/**
 * The single description normalization used by the server renderer and the
 * hydrated detail pages. Keeping the policy copy intact (apart from the
 * shared length limit) prevents crawler and browser metadata from disagreeing.
 */
export const SEO_META_DESCRIPTION_MAX_LENGTH = 160;

export function clampSeoDescription(
  value: string | null | undefined,
  maxLength = SEO_META_DESCRIPTION_MAX_LENGTH,
): string {
  const trimmed = value?.trim() ?? '';
  if (trimmed.length <= maxLength) return trimmed;
  // Drop a trailing lone high surrogate so a cut never splits an emoji.
  return `${trimmed.slice(0, Math.max(0, maxLength - 1)).replace(/[\uD800-\uDBFF]$/, '').trimEnd()}…`;
}
